// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from "react";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import StatusIndicator from "@cloudscape-design/components/status-indicator";

export interface EnrollmentSummaryProps {
  certificateSubject: string | null;
  certificateSerial: string | null;
  certificateNotAfter: string | null;
}

export default function EnrollmentSummary({
  certificateSubject,
  certificateSerial,
  certificateNotAfter,
}: EnrollmentSummaryProps): React.ReactElement {
  return (
    <Container header={<Header variant="h2">Enrollment Complete</Header>}>
      <SpaceBetween size="m">
        <StatusIndicator type="success">
          Certificate enrolled successfully
        </StatusIndicator>
        {certificateSubject && <p>Subject: {certificateSubject}</p>}
        {certificateSerial && <p>Serial Number: {certificateSerial}</p>}
        {certificateNotAfter && <p>Expires: {certificateNotAfter}</p>}
      </SpaceBetween>
    </Container>
  );
}
